import React, { useEffect, useState } from 'react';
import { CSVLink } from 'react-csv'; // Import CSVLink from react-csv
import DataTable from 'react-data-table-component';
import axios from 'axios';
import { Link } from 'react-router-dom';

const AirtableReport = ({ value, userId }) => {
  // Logs
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [airtableLogs, setAirtableLogs] = useState([]);
  const [clientUrl, setClientUrl] = useState('');

  // Logs Count

  const [startDateCount, setStartDateCount] = useState('');
  const [endDateCount, setEndDateCount] = useState('');
  const [airtableLogsCount, setAirtableLogsCount] = useState([]);
  const [clientUrlCount, setClientUrlCount] = useState('');

  useEffect(() => {
    if (value === 3) {
      fetchAirtableButtonLogsCount();
    }

    if (value === 4) {
      fetchAirtableButtonLogs();
    }
  }, [value]);

  const formatTimestamp = timestamp => {
    const date = new Date(timestamp);
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    };
    return date.toLocaleString('en-US', options).replace(',', '');
  };

  const customStyles = {
    rows: {
      style: {
        marginBottom: '10px',
        padding: '10px 0',
        borderBottom: '1px solid #ccc',
      },
    },
    tableWrapper: {
      style: {
        overflowX: 'auto',
      },
    },
    headCells: {
      style: {
        fontWeight: 'bold', // Bold header text
        fontSize: '16px', // Increase font size
        backgroundColor: '#f4f4f4', // Light gray background
      },
    },
  };

  // Prepare data for CSV export
  const csvDataAirtableLogs = (airtableLogs || []).map(client => ({
    'Date / Time': formatTimestamp(client.timestamp),
    RecordId: client.btnId,
    'Clicked Button': client.clickedButton || '',
    'Client URL': client.client_url || '',
  }));

  const csvDataAirtableLogsCount = (airtableLogsCount || []).map(client => ({
    RecordId: client._id,
    'Clicked Button': client.clickedButton || '',
    'Clicked Count': client.count || '',
    'Client URL': client.client_url || '',
  }));

  const fetchAirtableButtonLogs = async () => {
    try {
      const response = await axios.post('/api/airtable-logs', {
        userId: userId,
        startDate: startDate,
        endDate: endDate,
        client_url: clientUrl,
      });

      setAirtableLogs(response.data.airtableLogs); // Set the logs data
    } catch (error) {
      console.error('Error fetching button logs:', error);
    }
  };

  const fetchAirtableButtonLogsCount = async () => {
    try {
      const response = await axios.post('/api/airtable-logs-count', {
        userId: userId,
        startDate: startDateCount,
        endDate: endDateCount,
        client_url: clientUrlCount,
      });

      setAirtableLogsCount(response.data.stats); // Set the logs data
    } catch (error) {
      console.error('Error fetching button logs:', error);
    }
  };

  useEffect(() => {
    fetchAirtableButtonLogsCount();
  }, [startDateCount, endDateCount, clientUrlCount]);

  useEffect(() => {
    fetchAirtableButtonLogs();
  }, [startDate, endDate, clientUrl]);

  const columns = [
    {
      name: 'Date / Time',
      selector: row => formatTimestamp(row.timestamp),
      sortable: true,
      width: '250px',
    },
    {
      name: 'Record Id',
      selector: row => row.btnId,
      sortable: true,
      width: '250px',
    },
    {
      name: 'Clicked Button',
      selector: row => row.clickedButton || '',
      cell: row => (
        <div
          style={{
            maxWidth: '250px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {row.clickedButton ? row.clickedButton : ''}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Client URL',
      selector: row => row.client_url || '',

      cell: row => (
        <div
          style={{
            maxWidth: '250px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          <Link
            to={`/${row.client_url}`}
            target="_blank"
            style={{
              textDecoration: 'underline',
              color: 'blue',
              padding: '10px',
              borderRadius: '8px',
            }}
          >
            {row.client_url}
          </Link>
        </div>
      ),
      sortable: true,
      width: '200px',
    },
  ];

  const columns2 = [
    {
      name: 'Record Id',
      selector: row => row._id,
      sortable: true,
      width: '250px',
    },
    {
      name: 'Clicked Button',
      selector: row => row.clickedButton || '',
      cell: row => (
        <div
          style={{
            maxWidth: '250px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {row.clickedButton ? row.clickedButton : ''}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Clicked Count',
      selector: row => row.count || '',
      cell: row => (
        <div
          style={{
            maxWidth: '250px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {row.count ? row.count : ''}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Client URL',
      selector: row => row.client_url || '',
      cell: row => (
        <div
          style={{
            maxWidth: '250px',
            maxHeight: '200px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          <Link
            to={`/${row.client_url}`}
            target="_blank"
            style={{
              textDecoration: 'underline',
              color: 'blue',
              padding: '10px',
              borderRadius: '8px',
            }}
          >
            {row.client_url}
          </Link>
        </div>
      ),
      sortable: true,
      width: '200px',
    },
  ];

  if (value === 4) {
    return (
      <div className="p-10">
        <div className="p-4">
          <CSVLink
            data={csvDataAirtableLogs}
            filename={'airtablelogs.csv'}
            className="btn btn-success"
            style={{ padding: '10px', marginRight: '10px', float: 'right' }}
          >
            Download CSV
          </CSVLink>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="date"
              value={startDate}
              onChange={e => setStartDate(e.target.value)}
              className="form-control"
              style={{ width: '150px', marginRight: '10px' }}
            />
            <span style={{ marginRight: '10px' }}>to</span>
            <input
              type="date"
              value={endDate}
              onChange={e => setEndDate(e.target.value)}
              className="form-control"
              style={{ width: '150px' }}
            />
            <input
              type="text"
              value={clientUrl}
              onChange={e => setClientUrl(e.target.value)}
              //onBlur={() => fetchButtonLogs()} // Trigger your logic here

              className="form-control"
              placeholder="Search By Client Url"
              style={{ width: '250px', marginLeft: '20px' }}
            />
          </div>
        </div>

        <DataTable
          columns={columns}
          data={airtableLogs} // Use filtered data
          pagination
          paginationRowsPerPageOptions={[50, 100, 150, 200, 250, 300]}
          paginationPerPage={50}
          highlightOnHover
          customStyles={customStyles}
        />
      </div>
    );
  }

  if (value === 3) {
    return (
      <div className="p-10">
        <div className="p-4">
          <CSVLink
            data={csvDataAirtableLogsCount}
            filename={'airtablelogscount.csv'}
            className="btn btn-success"
            style={{ padding: '10px', marginRight: '10px', float: 'right' }}
          >
            Download CSV
          </CSVLink>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="date"
              value={startDateCount}
              onChange={e => setStartDateCount(e.target.value)}
              className="form-control"
              style={{ width: '150px', marginRight: '10px' }}
            />
            <span style={{ marginRight: '10px' }}>to</span>
            <input
              type="date"
              value={endDateCount}
              onChange={e => setEndDateCount(e.target.value)}
              className="form-control"
              style={{ width: '150px' }}
            />
            <input
              type="text"
              value={clientUrlCount}
              onChange={e => setClientUrlCount(e.target.value)}
              //onBlur={() => fetchButtonLogs()} // Trigger your logic here

              className="form-control"
              placeholder="Search By Client Url"
              style={{ width: '250px', marginLeft: '20px' }}
            />
          </div>
        </div>

        <DataTable
          columns={columns2}
          data={airtableLogsCount} // Use filtered data
          pagination
          paginationRowsPerPageOptions={[50, 100, 150, 200, 250, 300]}
          paginationPerPage={50}
          highlightOnHover
          customStyles={customStyles}
        />
      </div>
    );
  }
};

export default AirtableReport;
